export enum ModalTypeEnum {
  Lead = 'LEAD',
  Event = 'EVENT',
  Todo = 'TODO',
  Service = 'SERVICE',
  ServicePackage = 'SERVICE_PACKAGE',
  DeleteServiceConflict = 'DELETE_SERVICE_CONFLICT',
  RegisterSale = 'REGISTER_SALE',
  ChangePassword = 'CHANGE_PASSWORD',
  ManageBadges = 'MANAGE_BADGES',
  QuotaLimit = 'QUOTA_LIMIT',
  UpgradePrompt = 'UPGRADE_PROMPT',
  PlanUpgradeConfirm = 'PLAN_UPGRADE_CONFIRM',
  PlanDowngradeBlocked = 'PLAN_DOWNGRADE_BLOCKED',
  CancelSubscription = 'CANCEL_SUBSCRIPTION',
  InviteMember = 'INVITE_MEMBER',
  CollectDocument = 'COLLECT_DOCUMENT',
  Contractor = 'CONTRACTOR',
  ContractTemplate = 'CONTRACT_TEMPLATE',
  IssueContract = 'ISSUE_CONTRACT',
  SendForSignature = 'SEND_FOR_SIGNATURE',
  MessageTemplate = 'MESSAGE_TEMPLATE',
  MessageComposer = 'MESSAGE_COMPOSER',
  EventChecklist = 'EVENT_CHECKLIST',
  DeactivateLead = 'DEACTIVATE_LEAD',
  CreateGallery = 'CREATE_GALLERY',
  ManageGallery = 'MANAGE_GALLERY',
  Birth = 'BIRTH',
}
